import { isNotUndefined } from 'infrastructure/functions';

import {
  additionalFollowUpText,
  compareToLastReview,
  croOrDncText,
  reviewedReadings,
  needEscalateText,
  uniqueDaysText,
} from '../helpers';

import type { TMaSpO2YellowDataOptional } from '../../types';

export const spo2 = (data: TMaSpO2YellowDataOptional) => {
  let text = '';
  if (!data) return text;

  if (isNotUndefined(data.spo2DeviceFunctioningProperly)) {
    text += `Patient pulse oximeter ${
      data.spo2DeviceFunctioningProperly ? 'is' : 'is not'
    } functioning properly. `;
  }
  if (data.spo2DeviceFunctioningProperlyComment?.trim()) {
    text += `${data.spo2DeviceFunctioningProperlyComment}. `;
  }

  if (isNotUndefined(data.didPatientReportSpO2OrPulse)) {
    text += '\n';
    if (data.didPatientReportSpO2OrPulse) {
      text += `Patient reported the following difficulties with SpO2 or pulse readings: `;
    } else {
      text += `Patient has not reported any difficulties with SpO2 or pulse readings. `;
    }
  }
  if (data.didPatientReportSpO2OrPulseComment?.trim()) {
    if (data.didPatientReportSpO2OrPulse === undefined) text += '\n';
    text += `${data.didPatientReportSpO2OrPulseComment}. `;
  }

  const maReviewedReadingsText = reviewedReadings({
    template: 'MA',
    type: 'oximeter',
    atRiskNumber: data.atRiskNumber,
    thresholds: [
      {
        name: 'SpO2',
        lowValue: data.lowestSpO2,
        highValue: data.highestSpO2,
      },
      {
        name: 'pulse',
        lowValue: data.lowestPulse,
        highValue: data.highestPulse,
      },
    ],
  });
  if (maReviewedReadingsText.trim()) text += `\n${maReviewedReadingsText}`;

  const highTrendsItems = data.highTrends?.join(', ') ?? [];
  if (data.typeofTrend === 'high' && highTrendsItems.length > 0) {
    text += '\n';
    text += `High trends noted for the following: ${highTrendsItems}. `;
  }
  const lowTrendItems = data.lowTrends?.join(', ') ?? [];
  if (data.typeofTrend === 'low' && lowTrendItems.length > 0) {
    text += '\n';
    text += `Low trends noted for the following: ${lowTrendItems}. `;
  }
  if (data.typeofTrend === 'none') {
    text += '\n';
    text += 'No significant trends noted. ';
  }

  const comparedToLastReviewText = compareToLastReview(
    data.comparedToLastReview,
    data.comparedToLastReviewTrend,
  );
  if (comparedToLastReviewText.trim()) text += `\n${comparedToLastReviewText}`;

  if (isNotUndefined(data.uniqueDays)) {
    text += '\n';
    text += uniqueDaysText(data.uniqueDays);
  }

  if (croOrDncText(data).trim()) text += `\n${croOrDncText(data)}`;

  if (additionalFollowUpText(data).trim())
    text += `\n${additionalFollowUpText(data)}`;

  if (needEscalateText(data).trim()) text += `\n${needEscalateText(data)}`;

  if (data.freeTextComments?.trim()) text += `\n${data.freeTextComments}. `;

  return text;
};
